export default __webpack_public_path__ + "static/media/q33_v2.6fbed428.png";